import { MarkRendererProps } from "@sanity/block-content-to-react";
import React from "react";
import { LinkInfo } from "../../models/shared/LinkInfo";
import SanityLink from "../SanityLink";

interface Props {
  className?: string;
  sanityProps: React.PropsWithChildren<MarkRendererProps>;
}

const LinkRenderer = ({ className, sanityProps }: Props) => (
  <SanityLink className={className} {...(sanityProps.mark as LinkInfo)}>
    {sanityProps.children}
  </SanityLink>
);

export default LinkRenderer;
